interface HeroProps {
  onOpenLogin: () => void;
}

export default function Hero({ onOpenLogin: _onOpenLogin }: HeroProps) {
  return (
    <section className="relative py-[72px] pb-12 overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 opacity-90 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(250,204,21,0.12),transparent_55%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(244,114,182,0.18),transparent_60%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_90%,rgba(59,130,246,0.16),transparent_55%)]" />
      </div>

      <div className="relative z-[1] max-w-[1120px] mx-auto px-4 grid grid-cols-1 lg:grid-cols-[1.5fr_1fr] gap-8 items-center">
        {/* Hero Text */}
        <div>
          <h1 className="text-[clamp(2.1rem,3.1vw,2.8rem)] mb-3 font-bold text-[#e5e7eb]">
            Tarot virtual 24 horas por dia.
          </h1>
          <p className="mt-0 max-w-[560px] text-[#cbd5f5]">
            Consultores virtuais com estilos únicos, prontos para o orientar em
            Amor, Carreira, Espiritualidade, Finanças e muito mais. Compre minutos e fale por chat privado,
            sempre que precisar.
          </p>
          <div className="flex gap-3 my-5 flex-wrap">
            <a
              href="/#planos"
              className="inline-flex items-center justify-center rounded-full px-4 py-2 text-[0.95rem] font-medium bg-gradient-to-br from-[#8b5cf6] to-[#ec4899] text-[#f9fafb] shadow-[0_8px_20px_rgba(15,23,42,0.6)] hover:translate-y-[-1px] hover:brightness-105 transition-all"
            >
              Comprar minutos
            </a>
            <a
              href="/#consultores"
              className="inline-flex items-center justify-center rounded-full px-4 py-2 text-[0.95rem] font-medium border border-[rgba(249,250,251,0.5)] bg-transparent text-[#f9fafb] hover:bg-[rgba(15,23,42,0.9)] transition-colors"
            >
              Ver consultores
            </a>
          </div>
          <p className="text-[0.85rem] text-[#cbd5f5] max-w-[520px]">
            Serviço confidencial de entretenimento e orientação pessoal. Não substitui aconselhamento
            profissional médico, psicológico, financeiro ou legal.
          </p>
        </div>

        {/* Hero Card */}
        <div className="bg-[radial-gradient(circle_at_top,#111827,#020617_60%)] text-[#f9fafb] rounded-[18px] p-6 shadow-[0_22px_50px_rgba(15,23,42,0.85)] border border-[rgba(148,163,184,0.4)]">
          <h2 className="mt-0 mb-3 text-xl font-bold">Comece em 3 passos</h2>
          <ol className="pl-[18px] m-0 mb-4 space-y-2">
            <li>Crie a sua conta e compre minutos.</li>
            <li>Entre na área do cliente.</li>
            <li>Escolha um consultor e inicie o chat.</li>
          </ol>
          <a
            href="/#planos"
            className="w-full inline-flex items-center justify-center rounded-full px-4 py-2 text-[0.95rem] font-medium bg-gradient-to-br from-[#8b5cf6] to-[#ec4899] text-[#f9fafb] shadow-[0_8px_20px_rgba(15,23,42,0.6)] hover:translate-y-[-1px] hover:brightness-105 transition-all"
          >
            Ver pacotes de minutos
          </a>
        </div>
      </div>
    </section>
  );
}
